var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 17.25a.75.75 0 010 1.5H3.75a.75.75 0 010-1.5h16.5zM20.25 11.25a.75.75 0 010 1.5H3.75a.75.75 0 010-1.5h16.5zM20.25 5.25a.75.75 0 010 1.5H3.75a.75.75 0 010-1.5h16.5z",
    fill: "currentColor"
  })));
}
SvgBurgerMenu.displayName = 'BurgerMenu';
export default SvgBurgerMenu;